import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Link } from "gatsby"

import { Row, Col } from "./Grid"
import Button from "./Button"
import ImageContentful from "./ImageContentful"
import { ScreenReaderText } from "./Accessibility"

import { media, mixins } from "../styles"

const Header = styled.div`
  margin: 0 0 20px;
  position: relative;
  text-align: center;

  @media ${media.sm} {
    margin: 0 0 20px;
  }

  @media ${media.lg} {
    padding: 0 60px;
  }

  h1 {
    ${mixins.title2}
    margin: 0;

    img,
    svg {
      display: block;
      filter: saturate(0%) brightness(70%) contrast(1000%);
      height: auto;
      margin: 0 auto;
      max-width: 100%;
      width: 180px;

      @media ${media.md} {
        width: 240px;
      }

      @media ${media.xl} {
        width: 300px;
      }
    }
  }
`

const SubHeader = styled.h2`
  ${mixins.title5}
  align-items: center;
  display: flex;
  justify-content: center;
  line-height: 1;
  margin: 0 0 20px;

  @media ${media.md} {
    margin: 0 0 10px;
  }

  @media ${media.xl} {
    margin: 0 0 10px;
  }
`

const Icon = styled.span`
  flex: none;
  margin: 0 10px 0 0;
  height: 24px;
  width: 24px;

  img {
    max-height: 100%;
    max-width: 100%;
  }
`

const Text = styled.div`
  /* padding: 0 15px; */
  text-align: center;
  padding: 20px 0 10px;

  p {
    ${mixins.copy2}
    margin-bottom: 20px;
  }

  .button {
    @media ${media.sm} {
      margin-top: 5px;
    }
  }
`

const PageHeader = (props) => {
  const { header, text, linkText, linkUrl, subHeader, icon, logo } = props
  return (
    <Row>
      {header && (
        <Col sm="10" smOffset="1" md="8" mdOffset="2">
          <Header>
            {subHeader && (
              <SubHeader>
                {icon && (
                  <Icon aria-hidden="true">
                    <ImageContentful image={icon} alt="" inline />
                  </Icon>
                )}
                <span>{subHeader}</span>
              </SubHeader>
            )}
            {logo ? (
              <h1>
                {logo && <ImageContentful alt="" image={logo} />}
                <ScreenReaderText>{header}</ScreenReaderText>
              </h1>
            ) : (
              <h1>{header}</h1>
            )}
          </Header>
        </Col>
      )}

      <Col sm="10" smOffset="1" md="8" mdOffset="2">
        {text && <Text>{text}</Text>}
        {linkText && linkUrl && (
          <Button as={Link} to={linkUrl} arrow>
            {linkText}
          </Button>
        )}
      </Col>
    </Row>
  )
}

PageHeader.propTypes = {
  header: PropTypes.string.isRequired,
  subHeader: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
  icon: PropTypes.string,
  logo: PropTypes.object,
}

export default PageHeader
